import { Link } from "react-router-dom";

export function Footer() {
  return (
    <footer className="border-t border-neutral-200 py-6 mt-auto">
      <div className="mx-auto max-w-6xl px-4 flex flex-col md:flex-row items-center justify-between gap-2 text-xs text-neutral-500">
        <div>
          © 2026 DocLens · Built by{" "}
          <a href="https://trijazel.com" className="underline" target="_blank" rel="noreferrer">
            Trijazel
          </a>
        </div>
        <div className="flex gap-4">
          <Link to="/support">Support</Link>
          <Link to="/legal/privacy">Privacy</Link>
          <Link to="/legal/terms">Terms</Link>
        </div>
      </div>
    </footer>
  );
}
